<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 商品列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<!-- <el-select v-model="bill" placeholder="请选择评级订单" clearable>
					<el-option v-for="item in billList" :key="item.Id" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select> -->
				<el-input placeholder="商品标签码" class="handle-input mr10" v-model="code" clearable></el-input>
				<el-input placeholder="商品名称" class="handle-input mr10" v-model="goodsName" clearable></el-input>
				<el-input placeholder="订单编码" class="handle-input mr10" v-model="OrderCode" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-full-screen" @click="gaopaiyi">高拍仪拍照上传</el-button>
				<!-- <el-button type="primary" icon="el-icon-circle-plus-outline" @click="createGoods">创建商品</el-button> -->
			</div>
			<el-table :data="goodsList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<el-table-column prop="QRFont" label="商品标签码" align="center" min-width="150"></el-table-column>
				<el-table-column prop="Name" label="商品名称" align="center" min-width="250"></el-table-column>
				<!-- <el-table-column prop="Id" label="商品ID" align="center" min-width="300"></el-table-column> -->
				<!-- <el-table-column prop="Code" label="商品编码" align="center" min-width="300"></el-table-column> -->
				<el-table-column prop="OrderNum" label="订单编码" align="center" min-width="150"></el-table-column>
				<el-table-column prop="State" label="商品状态" min-width="120" align="center">
					<template #default="scope">
						<div v-for="(item) in stateList" :key="item">
							<el-tag v-if="scope.row.State==item.value">
								{{item.name}}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="CategoryName" label="商品分类" align="center" min-width="150"></el-table-column>
				<el-table-column prop="SerieName" label="商品系列" align="center" min-width="150"></el-table-column>
				<el-table-column prop="MemberName" label="会员" align="center" min-width="150"></el-table-column>
				<el-table-column fixed="right" label="操作" min-width="300" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"
							:disabled="scope.row.State==1?false:true">编辑
						</el-button>
						<!-- <el-button type="text" icon="el-icon-upload2" @click="photoBtn(scope.row)">编辑商品照片</el-button> -->
						<el-button type="text" icon="el-icon-picture" @click="lookPhoto(scope.row)">查看商品照片</el-button>
						<el-button type="text" icon="el-icon-delete" @click="deleGoods(scope.row)" style="color: red;"
							v-if="scope.row.State==6?false:true">
							删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>


			<!-- 编辑弹出框 查看弹出框-->
			<el-dialog :title="title" v-model="editVisible" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="商品标签码" prop="QRFont">
						<el-input v-model="ruleForm.QRFont" disabled></el-input>
					</el-form-item>
					<el-form-item label="商品名称" prop="Name">
						<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="商品分类" prop="CategoryId">
						<el-select v-model="ruleForm.CategoryId" clearable placeholder="请选择类别名称" @change='changeClass'
							:disabled="isdisabled">
							<el-option v-for="item in classList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品系列" prop="SerieId">
						<el-select v-model="ruleForm.SerieId" clearable placeholder="请选择系列名称" :disabled="isdisabled">
							<el-option v-for="item in serList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
					</span>
				</template>
			</el-dialog>


			<!-- 高拍仪弹出-->
			<el-dialog :title="title" style="overflow: hidden;" v-model="isGaopaiyi" @opened="openPhotoDialog"
				@close="closePhotoDialog" width="600px" id="photoDialog" class="photoDialog" customClass="photoDialog">
				<el-tabs v-model="activeName" @tab-click="tabClick" class="photoTabs">
					<el-tab-pane label="正面" name="tab1">
						<div class="photo-pane">
							<a :href="photoList1.Url" target="_blank">
								<el-image id="photo1" class="photoImg" :src="photoList1.Url"
									style="object-fit:contain;border-radius: 10px;">
								</el-image>
							</a>
							<span v-show="photoList1==''?true:false">无照片</span>
						</div>
						<ul class="photo-fun">
							<li><el-input style="width: 75px;" class="text" size="mini"
									v-model="ruleForm.QRFont"></el-input></li>
							<li><el-button size="mini" @click="connection()" :disabled="!btDisabled1"
									icon="el-icon-key"><span>连接</span></el-button></li>
							<li><el-button size="mini" @click="deskew()" :disabled="btDisabled1"
									icon="el-icon-full-screen"><span>识别</span></el-button></li>
							<li><el-button size="mini" @click="rotate()" :disabled="btDisabled1"
									icon="el-icon-refresh-right"><span>旋转</span></el-button></li>
							<li><el-button size="mini" @click="zoomIn()" :disabled="btDisabled1"
									icon="el-icon-zoom-in"><span>放大</span></el-button></li>
							<li><el-button size="mini" @click="zoomOut()" :disabled="btDisabled1"
									icon="el-icon-zoom-out"><span>缩小</span></el-button></li>
							<li><el-button size="mini" @click="captureToFile()" :disabled="btDisabled1" type="success"
									icon="el-icon-camera"><span>拍照</span></el-button>
							</li>
						</ul>
					</el-tab-pane>
					<el-tab-pane label="反面" name="tab2">
						<div class="photo-pane">
							<a :href="photoList2.Url" target="_blank">
								<el-image id="photo2" class="photoImg" :src="photoList2.Url"
									style="object-fit:contain;border-radius: 10px;"></el-image>
							</a>
							<span v-show="photoList2==''?true:false">无照片</span>
						</div>
						<ul class="photo-fun">
							<li><el-input style="width: 75px;" class="text" size="mini"
									v-model="ruleForm.QRFont"></el-input></li>
							<li><el-button size="mini" @click="connection()" :disabled="!btDisabled2"
									icon="el-icon-key"><span>连接</span></el-button></li>
							<li><el-button size="mini" @click="deskew()" :disabled="btDisabled2"
									icon="el-icon-full-screen"><span>识别</span></el-button></li>
							<li><el-button size="mini" @click="rotate()" :disabled="btDisabled2"
									icon="el-icon-refresh-right"><span>旋转</span></el-button></li>
							<li><el-button size="mini" @click="zoomIn()" :disabled="btDisabled2"
									icon="el-icon-zoom-in"><span>放大</span></el-button></li>
							<li><el-button size="mini" @click="zoomOut()" :disabled="btDisabled2"
									icon="el-icon-zoom-out"><span>缩小</span></el-button></li>
							<li><el-button size="mini" @click="captureToFile()" :disabled="btDisabled2" type="success"
									icon="el-icon-camera"><span>拍照</span></el-button>
							</li>
						</ul>
					</el-tab-pane>
				</el-tabs>
			</el-dialog>


			<!-- 查看照片弹出框-->
			<el-dialog :title="title" v-model="showphoto" width="500px">
				<el-form label-width="100%" ref="ruleForm" :model="ruleForm" :rules="rules"
					style="display: flex;justify-content: center;text-align: center;">
					<el-tabs v-model="activeName2" @tab-click="tabClick" class="photoTabs">
						<el-tab-pane label="正面" name="tab1">
							<div class="photo-pane">
								<a :href="photoList1.Url" target="_blank">
									<el-image id="photo1" class="photoImg" :src="photoList1.Url"
										style="object-fit:contain;border-radius: 10px;"></el-image>
								</a>
								<span v-show="photoList1==''?true:false">无照片</span>
							</div>
						</el-tab-pane>
						<el-tab-pane label="反面" name="tab2">
							<div class="photo-pane">
								<a :href="photoList2.Url" target="_blank">
									<el-image id="photo1" class="photoImg" :src="photoList2.Url"
										style="object-fit:contain;border-radius: 10px;"></el-image>
								</a>
								<span v-show="photoList2==''?true:false">无照片</span>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-form>
			</el-dialog>

		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				activeName: 'tab2',
				activeName2: 'tab1',
				btDisabled1: true,
				btDisabled2: true,
				socket: '',
				title1: '',
				title2: '',
				OrderCode: '', //订单编码
				goodsName: '',
				showphoto: false,
				code: '', //商品编号
				pingjiList: [],
				title: '',
				goodsList: [],
				billList: [],
				ruleForm: [],
				token: localStorage.getItem('access_token'),
				roleid: localStorage.getItem('RoleId'),
				Id: localStorage.getItem('Id'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				editVisible: false,
				rules: {
					BillId: [{
						required: true,
						message: '请输入订单',
						trigger: 'change'
					}],
					Name: [{
						required: true,
						message: '请输入订单名称',
						trigger: 'blur'
					}],
					SerieId: [{
						required: true,
						message: '请选择系列名称',
						trigger: 'change'
					}],
					CategoryId: [{
						required: true,
						message: '请选择分类名称',
						trigger: 'change'
					}],
					Phone: [{
						required: true,
						message: '请输入收件人手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[0123456789]\d{9}$/,
						message: '目前只支持中国大陆的手机号码',
						trigger: "blur"
					}],
					SpeedNum: [{
						required: true,
						message: '请选择是否快评',
						trigger: 'blur'
					}],
					ExpressCompany: [{
						required: true,
						message: '请输入快递公司',
						trigger: 'blur'
					}],
					TrackingNum: [{
						required: true,
						message: '请输入快递单号',
						trigger: 'blur'
					}],
				},
				isdisabled: false,

				kuaipingList: [{
						Id: 1,
						Name: '普通快评'
					},
					{
						Id: 2,
						Name: '加急快评'
					}
				],
				startTime: '', //开始时间
				endTime: '', //结束时间
				stateList: [{
					name: "正常",
					value: 1
				}, {
					name: "一人已打分",
					value: 2
				}, {
					name: "二人已打分",
					value: 3
				}, {
					name: "三人已打分",
					value: 4
				}, {
					name: "总分已评",
					value: 5
				}, {
					name: "已打印",
					value: 6
				}],
				bill: '',
				billId: '',
				upResName: '',
				upResName2: '',
				treeList: [],
				treeList2: [],
				defaultProps: {
					children: 'children',
					label: 'Name',
				},
				defaultProps2: {
					children: 'children',
					label: 'Name',
				},
				fillist: [],
				isphoto: false,
				isGaopaiyi: false,
				photoList1: {},
				photoList2: {},
				classList: [],
				serList: []
			}
		},
		created() {
			this.getGoodsList()
			this.getbillList()
			this.getclass()

		},
		mounted() {
			//this.changeStyle();
		},
		methods: {


			openPhotoDialog() {
				//调整photoDialog 上边距
				// let eldialog = document.getElementsByClassName('el-dialog');
				// if (eldialog) {
				// 	eldialog[0].style.overflow = 'hidden'
				// }

				if (this.photoList1.Url == '' || this.photoList1.Url == undefined) {
					this.photoList1.Url = 'http://api.tjfcs.cn/Upload/no.jpg'
				}
				if (this.photoList2.Url == '' || this.photoList2.Url == undefined) {
					this.photoList2.Url = 'http://api.tjfcs.cn/Upload/no.jpg'
				}
			},
			closePhotoDialog() {
				this.disconnect();
			},

			tabClick(e) {

				this.closeDevice();
				//console.log(this.activeName);
			},
			base64toFile(dataurl, filename) {
				var arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new File([u8arr], filename, {
					type: mime
				});
			},
			//改变分类改变系列
			changeClass(val) {
				console.log(val)
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetSeries?&pageSize=99999" + '&name=' + '' + '&pageIndex=0' +
						'&categoryId=' + val,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Data == '') {
						this.serList = res.data.Data
						this.ruleForm.SerieId = ''
					} else {
						this.serList = res.data.Data
						this.ruleForm.SerieId = this.serList[0].Id
					}
				})
			},

			//正面图片上传
			beforeAvatarUpload1(file) {
				let dian = file.name.lastIndexOf('.')
				let type = file.name.substr(dian + 1)
				const isLt2M = file.size / 1024 / 1024 < 2
				console.log(isLt2M)
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过2M!')
				} else if (type != 'xls' && type != 'pdf' && type != 'jpg' && type != 'png' && type != 'xlsx' &&
					type != 'bmp' && type != 'jpeg' &&
					type != 'XLS' && type != 'PDF' && type != 'JPG' && type != 'PNG' && type != 'XLSX' && type !=
					'BMP' && type != 'JPEG') {
					this.$message.error('上传图片必须是 xls / pdf / jpg / png / xlsx / bmp / jpeg 格式!');
				} else {
					let formdata = ''
					formdata = new FormData()
					formdata.append('file', file)
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "CollectiblesPhotoUpload",
						data: formdata
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							res.data.Data[0].Url = res.data.Data[0].url
							if (this.title1 == '修改') {
								this.photoList1.Url = res.data.Data[0].url
							} else if (this.title1 == '添加') {
								this.photoList1 = res.data.Data[0]
								this.photoList1.Url = res.data.Data[0].url
								this.photoList1.State = 1
								console.log(this.photoList1)
							}
						}
					})
				}

			},
			//反面图片上传
			beforeAvatarUpload2(file) {
				let dian = file.name.lastIndexOf('.')
				let type = file.name.substr(dian + 1)
				const isLt2M = file.size / 1024 / 1024 < 1
				console.log(isLt2M)
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过2M!')
				} else if (type != 'xls' && type != 'pdf' && type != 'jpg' && type != 'png' && type != 'xlsx' &&
					type != 'bmp' && type != 'jpeg' &&
					type != 'XLS' && type != 'PDF' && type != 'JPG' && type != 'PNG' && type != 'XLSX' && type !=
					'BMP' && type != 'JPEG') {
					this.$message.error('上传图片必须是 xls / pdf / jpg / png / xlsx / bmp / jpeg 格式!');
				} else {
					let formdata = ''
					formdata = new FormData()
					formdata.append('file', file)
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "CollectiblesPhotoUpload",
						data: formdata
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							res.data.Data[0].Url = res.data.Data[0].url
							if (this.title2 == '修改') {
								this.photoList2.Url = res.data.Data[0].url
							} else if (this.title2 == '添加') {
								this.photoList2 = res.data.Data[0]
								this.photoList2.Url = res.data.Data[0].url
								this.photoList2.State = 2
							}
						}
					})
				}
			},

			handleExceed(fileList) {
				console.log(fileList)
				this.$message.error("当前选择图片为 " + fileList.length + " 张,只可以传 2 张图片!")
			},
			//高拍仪图片上传
			newUploadCapture(imgBase64, self) {
				let file = this.base64toFile(imgBase64, '1.jpg');
				let formdata = new FormData();
				formdata.append('file', file);

				axios({
					method: 'post',
					url: this.$store.state.pcurl + "CollectiblesPhotoUpload",
					data: formdata
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						res.data.Data[0].Url = res.data.Data[0].url
						if (this.activeName == 'tab1') {
							this.photoList1.Url = res.data.Data[0].url
							this.photoList1.State = 1
						} else if (this.activeName == 'tab2') {
							this.photoList2.Url = res.data.Data[0].url
							this.photoList2.State = 2
						}
						this.uploadPhoto(self);
						this.disconnect();
					}
				})
			},

			//确认上传
			uploadPhoto() {
				this.ruleForm.CreateUserId = this.Id
				this.ruleForm.CollectiblesId = this.ruleForm.Id
				this.ruleForm.Url = ''
				this.photoList = []
				if (this.ruleForm.QRFont == '' || this.ruleForm.QRFont == undefined) {
					this.$message({
						message: '商品标签码不能为空',
						type: 'error'
					});
					return;
				}
				if (this.activeName == 'tab1') {
					this.ruleForm.Id = this.photoList1.Id
					this.ruleForm.State = this.photoList1.State = 1
					this.ruleForm.Url = this.photoList1.Url

				}
				if (this.activeName == 'tab2') {
					this.ruleForm.Id = this.photoList2.Id
					this.ruleForm.State = this.photoList2.State = 2
					this.ruleForm.Url = this.photoList2.Url
				}
				//console.log(this.ruleForm);
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "MergCollectiblesPhoto2",
					headers: {
						"Authorization": "bearer " + this.token
					},
					data: this.ruleForm
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.$message({
							message: '上传成功!',
							type: 'success'
						});
						//console.log(this.photoList1);
						this.isphoto = false
						this.getGoodsList()
					}
				})


			},
			//修改商品照片
			updataGoodsImg(obj) {
				console.log(obj)
			},

			//编辑商品照片（废弃）
			photoBtn(row) {
				this.btDisabled1 = true
				this.btDisabled2 = true
				this.title = '高拍仪识别上传'
				this.photoList1 = {}
				this.photoList2 = {}
				this.title1 = '添加'
				this.title2 = '添加'
				this.isphoto = true,
					this.ruleForm = '',
					// this.ruleForm = row
					this.ruleForm.photoList = [];
				// console.log(this.ruleForm)
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPhotos?biilId=" + row.BillId +
						'&collectiblesId=' + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).
				then((res) => {
					if (res.data.Data.length > 0) {
						this.ruleForm.photoList = res.data.Data;
						//获取照片，如果有照片，将标题变成修改
						res.data.Data.forEach((x) => {
							if (x.State == 1) {
								this.photoList1 = x
							} else {
								this.photoList2 = x
								//this.title2 = '修改'
							}
						})
					}

				})

			},
			deleGoods(row) {
				console.log(row.Id)
				this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "DeleteCollectiblesPool?Id=" + row.Id,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getGoodsList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//查看商品照片
			lookPhoto(row) {
				console.log(row)
				this.isphoto = true
				this.photoList = []
				this.title = '查看商品照片'
				this.showphoto = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPhotos?biilId=" + row.BillId +
						'&collectiblesId=' + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {

						if (res.data.Data.length == 0) {
							this.photoList1.Url = 'http://api.tjfcs.cn/Upload/no.jpg'
							this.photoList2.Url = 'http://api.tjfcs.cn/Upload/no.jpg'
						} else {
							res.data.Data.forEach((x) => {
								if (x.State == 1) {
									this.photoList1 = x
								}
								if (x.State == 2) {
									this.photoList2 = x
								}
								this.photoList.push(x)
							})
						}

					}
				})
			},
			handleNodeClick(data) {
				this.upResName = data.Name
				this.ruleForm.SerieId = data.Id
			},
			handleNodeClick2(data) {
				this.upResName2 = data.Name
				this.ruleForm.CategoryId = data.Id
				//console.log(data)
			},
			buildTree(arr, ParentId) {
				let tree = [];
				arr.map((item) => {
					if (item.ParentId === ParentId) {
						item.children = this.buildTree(arr, item.Id);
						tree.push(item);
					}
				});
				return tree;
			},
			//获取全部系列
			getSerie() {

			},
			//获取全部分类
			getclass() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCategories?&pageSize=99999" + '&name=' + '' +
						'&pageIndex=0',
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					this.classList = res.data.Data
				})
			},
			handleClear(obj) {
				// 将选择器的值置空
				if (obj == 'class') {
					this.upResName2 = ''
					this.ruleForm.CategoryId = ''
				} else {
					this.upResName = ''
					this.ruleForm.SerieId = ''
				}

			},
			//获取全部订单
			getbillList() {
				this.billList = []
				axios({
					method: 'get',
					url: this.$store.state.pcurl + 'GetBills?pageSize=999999' + '&state=' + '1,2,3,4,5,6,7',
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.billList = res.data.Data
				})
			},
			//创建商品
			createGoods() {
				this.ruleForm = []
				this.isdisabled = false
				this.title = '创建商品'
				this.editVisible = true
				this.upResName = ''
				this.upResName2 = ''


				axios({
					method: 'post',
					url: this.$store.state.pcurl + 'QRFont',
				}).then((res) => {
					//console.log(res.data)
					this.ruleForm.QRFont = res.data
				})
			},
			//获取商品列表
			getGoodsList() {
				let addUserId = ''
				if (this.roleid == 'a591fe1e-7da8-4124-8912-b5af5282d57a') {
					addUserId = this.Id
				}
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + 'GetCollectibles?pageSize=' + this.pageSize +
						'&pageIndex=' + pageIndex + '&QRFont=' + this.code + '&name=' + this.goodsName +
						'&orderNum=' + this.OrderCode + '&addUserId=' + addUserId,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.pageTotal = res.data.Count
					console.log(res.data.Data)
					this.goodsList = res.data.Data
					this.goodsList.forEach((x) => {

						axios({
							method: 'get',
							url: this.$store.state.pcurl + 'GetCollectiblesPoolModel?Id=' +
								x.Id,
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							x.QRFont = res.data.Data.QRFont
							x.QRCode = res.data.Data.QRCode
						})

						if (x.CategoryId) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + 'GetCategoryModel?categoryId=' +
									x.CategoryId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Data) {
									x.CategoryName = res.data.Data.Name
								}
							})
						}
						if (x.SerieId) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + 'GetSeriesModel?seriesId=' +
									x.SerieId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Data) {
									x.SerieName = res.data.Data.Name
								}
							})
						}
						if (x.MemberUserId) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + 'GetUserModel?userId=' +
									x.MemberUserId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								x.MemberName = res.data.Data.Name
							})
						}
					})
				})
			},
			//监听时间变化
			changeTime() {
				let start = JSON.stringify(this.value2[0])
				let end = JSON.stringify(this.value2[1])
				this.startTime = JSON.parse(start).replace(/T|\.\d{3}Z/g, " ")
				this.endTime = JSON.parse(end).replace(/T|\.\d{3}Z/g, " ")
				console.log(this.startTime, this.endTime)
			},
			//搜索
			handleSearch() {
				this.pageIndex = 1
				this.billId = this.bill
				this.getGoodsList()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getGoodsList()
			},
			//查看
			handleClick(row) {
				//console.log(row)
				this.title = '查看商品'
				this.isdisabled = true
				this.editVisible = true
				this.ruleForm = row
				this.ruleForm.MemberUserId = row.MemberName
				this.ruleForm.SerieId = row.SerieName
				this.ruleForm.CategoryId = row.CategoryName
			},
			// 编辑商品
			handleEdit(index, row) {
				this.title = '编辑商品信息'
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPoolModel?Id=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					//console.log(this.ruleForm)

					axios({
						method: 'get',
						url: this.$store.state.pcurl +
							"GetCategoryModel?categoryId=" + this.ruleForm.CategoryId,
						headers: {
							Authorization: 'bearer ' + this.token
						}
					}).then((res) => {
						if (!res.data.Data) {
							this.ruleForm.CategoryId = ''
							this.ruleForm.SerieId = ''
						}
					})

					axios({
						method: 'get',
						url: this.$store.state.pcurl +
							"GetSeriesModel?seriesId=" + this.ruleForm.SerieId,
						headers: {
							Authorization: 'bearer ' + this.token
						}
					}).then((res) => {
						if (!res.data.Data) {
							this.ruleForm.SerieId = ''
						}
					})


					if (!this.ruleForm.CategoryId) {
						this.ruleForm.CategoryId = ''
						this.ruleForm.SerieId = ''
					} else {
						axios({
							method: 'get',
							url: this.$store.state.pcurl + "GetSeries?&pageSize=99999" + '&name=' + '' +
								'&pageIndex=0' + '&categoryId=' + row.CategoryId,
							headers: {
								Authorization: 'bearer ' + this.token
							}
						}).then((res) => {
							if (res.data.Data) {
								this.serList = res.data.Data
							}
						})
					}

					if (!this.ruleForm.SerieId) {
						this.ruleForm.SerieId = ''
					}

					this.editVisible = true
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '创建商品') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + "GetBillModel?billId=" + this.ruleForm
									.BillId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								//console.log(res.data.Data)
								this.ruleForm.MemberUserId = res.data.Data.MemberUserId
								this.ruleForm.AddUserId = this.Id
								this.ruleForm.CreateType = 2
								this.ruleForm.State = 1
								//console.log(this.ruleForm)
								axios({
									method: 'post',
									url: this.$store.state.pcurl + "AddCollectiblesPool",
									data: qs.stringify(this.ruleForm),
									headers: {
										"Authorization": "bearer " + this.token
									},
								}).then((res) => {
									if (res.data.Message == '请求成功') {
										this.editVisible = false
										this.$message({
											message: '创建成功',
											type: 'success'
										})
										//console.log(this.ruleForm)
										this.getGoodsList()
									} else {
										this.$message.error('创建失败')
									}
								})
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '编辑商品信息') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + "GetBillModel?billId=" + this.ruleForm
									.BillId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								this.ruleForm.MemberUserId = res.data.Data.MemberUserId
								axios({
									method: 'post',
									url: this.$store.state.pcurl + "UpdateCollectiblesPool",
									data: qs.stringify(this.ruleForm),
									headers: {
										"Authorization": "bearer " + this.token
									},
								}).then((res) => {
									if (res.data.Message == '请求成功') {
										this.editVisible = false
										this.$message({
											message: '修改成功',
											type: 'success'
										})
										//console.log(this.ruleForm)
										this.getGoodsList()
									} else {
										this.$message.error('修改失败')
									}
								})
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.editVisible = false
				}
			},


			connection() {

				var self = this;
				self.isBtDisabled(false);
				var host = "ws://localhost:7000/"
				try {
					self.socket = new WebSocket(host);
					self.socket.onopen = function(msg) {

						msg.target.send("OpenIdCardEx@0");
						msg.target.send("OpenDevice@1");
						msg.target.send("SetResolution@2@51409@4000");
						msg.target.send("OpenVideo");
					};

					self.socket.onmessage = function(msg) {
						if (typeof msg.data == "string") {
							if (msg.data.indexOf("GetDevCount") == 0) {
								var s = msg.data.substring(12);

								if ('1' == s || '2' == s) { //如果是双摄像头 那就需要判断 s = 2;表示当前是连接了2个设备
									alert("检测到已经连接上摄像头");

								} else {
									alert("没有连接摄像头");
								}

							} else if (msg.data.indexOf('CloseDevice') == 0) {
								//var s = msg.data.substring(12);
								//self.isBtDisabled(true);

							} else if (msg.data.indexOf('CloseVideo') == 0) {
								//var s = msg.data.substring(11);
								//self.isBtDisabled(true);

							} else if (msg.data.indexOf('OpenVideo') == 0) {

								var s = msg.data.substring(10);
								if ('1' == s) {
									self.$message({
										message: '高拍仪已连接',
										type: 'success'
									})
								} else {
									self.$message({
										message: '高拍仪未连接',
										type: 'warning'
									})
								}
							} else if (msg.data.indexOf('Deskew') == 0) {

								self.$message({
									message: '开启识别',
									type: 'success'
								})
							} else if (msg.data.indexOf('CaptureToFile') == 0) {
								var s = msg.data.substring(14);
								if ('1' == s) {
									self.$message({
										message: '保存成功',
										type: 'success'
									})
								} else {
									self.$message({
										message: '失败',
										type: 'warning'
									})
								}

							} else if (msg.data.indexOf('Capture') == 0) {

								let s = msg.data.substring(8);
								let base64 = "data:image/jpeg;base64," + s;
								//console.log(s)
								self.newUploadCapture(base64, self);
								//var myimg = document.getElementById("myCanvas2");
								//this.socket.send("ClearImageList");
								//this.socket.send("AddBase64ToImageList@" + s);
								// this.socket.send("AddBase64ToImageList@" + s);
								//this.socket.send("AddFileToImageList@D:/1.jpg");
								//this.socket.send("MakeImageListFileEx@D:/1.pdf");

							} else if (msg.data.indexOf('MakeImageListFileEx') == 0) {
								var s = msg.data.substring(20);
								if ('1' == s) {
									alert("pdf保存成功");
								} else {
									alert("pdf保存失败")
								}

							} else if (msg.data.indexOf('MoveDetectEvent') == 0) {
								self.socket.send("Capture@2");
							} else if (msg.data.indexOf('IdCardEvent') == 0) {
								self.socket.send("UnFaceDetect");
								self.socket.send("ReadIdCard");
							} else if (msg.data.indexOf('ReadIdCard') == 0) {
								var s = msg.data.substring(11);
								if ('1' == s) {
									self.socket.send("GetIdCardResult");
									self.socket.send("GetIdCardImage@2");
								}
							} else if (msg.data.indexOf('GetIdCardResult') == 0) {
								var s = msg.data.substring(16);

								var info = document.getElementById('info');
								info.value = s;
							} else if (msg.data.indexOf('GetBarcode') == 0) {
								if (msg.data.indexOf('qr') >= 0) {
									self.ruleForm.QRFont = msg.data.split('=')[1];
									self.showQrFont();
								} else {
									self.$message({
										message: '二维码识别失败',
										type: 'error'
									})
								}

								//var s = msg.data.substring(11);
								//var info = document.getElementById('info');
								//info.value = s;
							} else if (msg.data.indexOf('BarcodeResultEvent') == 0) {
								var s = msg.data.substring(19);

								var arr = s.split("#");
								if (arr[0] == "0") {
									var info = document.getElementById('info');
									info.value = arr[2];
									self.socket.send("StopGetBarcodeEx");
								}
							} else if (msg.data.indexOf('GetIdCardImage') == 0) {
								var s = msg.data.substring(15);
								var arr = s.split("#");
								var faceImg = arr[2];

								var myimg = document.getElementById("myCanvas3");
								myimg.src = "data:image/jpeg;base64," + faceImg;
							} else if (msg.data.indexOf('GetBase64') == 0) {
								var s = msg.data.substring(10);
								alert(s);
								self.socket.send("DeleteFile@D://1.pdf");

								var myimg = document.getElementById("myCanvas2");
								myimg.src = "data:image/jpeg;base64," + s;
							} else if (msg.data.indexOf('GetRecognitionFromFileName') == 0) {
								var s = msg.data.substring(27);

								var info = document.getElementById('info');
								info.value = s;
							} else if (msg.data.indexOf('GetOcrFromFileName') == 0) {
								var s = msg.data.substring(19);

								var info = document.getElementById('info');
								info.value = s;
							}
						} else {
							var reader = new FileReader();
							reader.onload = function(msg) {
								if (msg.target.readyState == FileReader.DONE) {
									var url = msg.target.result;
									//照片画布高拍仪显示
									if (self.activeName == 'tab1' && self.btDisabled1 == false) {
										let photo1 = document.getElementById('photo1');
										if (photo1) {
											photo1.src = url;
										}
									} else if (self.activeName == 'tab2' && self.btDisabled2 == false) {
										let photo2 = document.getElementById('photo2');
										if (photo2) {
											photo2.src = url;
										}
									}
								}
							}
							reader.readAsDataURL(msg.data);
						}
					};
					// self.socket.onclose = function(msg) {
					// };
				} catch (ex) {
					//log(ex);
					this.$message({
						message: '出现错误，请刷新重试',
						type: 'warning'
					});
				}
			},
			opendevice() {
				this.socket.send("OpenDevice@1");
				this.socket.send("SetResolution@2@51409@4000");
				this.socket.send("OpenVideo");
			},
			zoomIn() {
				if (this.socket) {
					this.socket.send("ZoomIn");
				}
			},
			zoomOut() {
				if (this.socket) {
					this.socket.send("ZoomOut");
				}
			},
			captureToFile() {
				if (this.ruleForm.QRFont == '' || this.ruleForm.QRFont == undefined) {
					this.$message({
						message: '上传失败，商品标签码不能为空',
						type: 'error'
					});
					return;
				}
				if (this.socket) {
					this.socket.send("Capture@2");
				}
				// let commd = "CaptureToFile@" + this.fileName;
				// this.socket.send(commd);

			},
			deskew() {
				if (this.socket) {
					this.socket.send("Deskew");
					if (this.activeName == 'tab2') {
						this.socket.send("GetBarcode");
					}
				}
			},
			rotate() {
				if (this.socket) {
					this.socket.send("RotateRight");
				}
			},
			disconnect() {
				if (this.socket) {
					this.socket.send("CloseDevice");
					this.socket.close();
					this.socket = null;
				}

				this.isBtDisabled(true);

			},
			closeDevice() {

				this.isBtDisabled(true);
				if (this.socket) {
					this.socket.send("CloseDevice");
					this.socket.send("CloseVideo");

				}
			},
			isBtDisabled(isTrue) {

				// if (this.activeName == 'tab1') {
				// 	this.btDisabled1 = !isTrue;
				// } else {
				// 	this.btDisabled2 = !isTrue;
				// }
				this.$nextTick(() => {
					if (this.activeName == 'tab1') {
						this.btDisabled1 = isTrue;
					} else {
						this.btDisabled2 = isTrue;
					}
				})

			},
			refreshs(isTrue) {
				let self = this;
				this.$nextTick(() => (
					self.isBtDisabled(isTrue)
				))
			},
			gaopaiyi() {
				this.activeName='tab2'
				this.btDisabled1 = true
				this.btDisabled2 = true
				this.title = '高拍仪拍照上传'
				this.photoList1 = {}
				this.photoList2 = {}
				this.isGaopaiyi = true
				this.ruleForm = {}
				this.ruleForm.photoList = [];
				this.ruleForm.QRFont = ''
			},
			showQrFont() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + 'GetCollectibles?QRFont=' + this.ruleForm.QRFont,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Data.length > 0) {
						this.ruleForm.QRFont = res.data.Data[0].QRFont
						this.$message({
							message: this.ruleForm.QRFont,
							type: 'success'
						})
					}

				})
			},

		}
	};
</script>

<style scoped>
	.el-select {
		width: 100%;
		margin-right: 10px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(.el-upload) {
		width: 56px;
		height: 32px;
		border: none;
		line-height: 0;
	}

	:deep(.el-upload-list) {
		height: 0px !important;
	}

	:deep(.el-upload-list--text) {
		overflow: visible !important;
	}

	:deep(.el-form-item__label) {
		width: 120px !important;
	}

	:deep(.el-form-item__content) {
		margin-left: 120px !important;
	}


	.listPhoto {
		width: 514px;
		height: 430px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
	}

	.listPhoto .panel {
		width: 45%;

	}

	.listPhoto .panel el-image {
		width: 100%;
		border-radius: 8px;
	}

	.photo-fun {
		list-style: none;
		padding: 0px;
		margin: 0px;

	}

	.bg_btn .el-button--mini {
		border-radius: inherit;
	}

	.photo-fun li {
		margin-left: 5px;
		list-style: none;
		display: inline-block;
		padding-top: 10px;
	}

	.photo-fun li .bt-mini {
		padding: 3px 5px !important;
		width: 40px !important;
	}


	.photo-fun /deep/ .el-input__inner {
		padding: 3px !important;
		width: 75px !important;
	}


	.el-dialog {
		overflow: hidden;
	}

	.photoDialog {
		overflow: hidden;
		/* 	width: 500px !important;
		min-width: 500px !important;
		max-width: 500px !important; */
	}

	.photoTabs {
		margin-top: 0px;
		padding-top: 0px !important;
		width: 100%;
	}

	.photoDialog .photo-pane {
		height: 500px;
		width: 100%;
		background-color: #eee;
		margin: 0 auto;
		display: inline-flex;
		text-align: center;
		justify-content: center;
	}

	.photoDialog .photo-pane span {
		position: absolute;
		top: 40%;
		font-size: 20px;
	}

	.photoDialog .photo-pane img {
		height: 500px;
	}


	/* 	.el-dialog__body {
		padding-top: 0px 20px 20px 20px !important;
	} */

	.photoImg {
		height: 500px;
	}

	:deep(.el-dialog) {
		max-height: 720px !important;
	}
</style>